import {useContext, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import {APICreateMyMap} from "../../api/maps/Maps";
import {NewOrderModal} from "../dialogs/newOrderModal";



export const CardGridEmpty = ({dialog, actions}) => {
    const { user } = useContext(UserContext);
    const [openNewOrderModal, setOpenNewOrderModal] = useState(false);

    const navigate = useNavigate();

    const newItem = async (type) => {
        if (type === "map") {
            const mapId = await APICreateMyMap(user);
            if (!mapId) return;
            navigate(`/maps/${mapId}`);
        }
    }

    return (
        <div className={" m-auto w-10/12 sm:w-8/12 lg:w-6/12 xl:w-4/12 text-center"}>
            {(actions?.orderCreation === true) && (<NewOrderModal openNewOrderModal={openNewOrderModal} setOpenNewOrderModal={setOpenNewOrderModal} />)}
            <center>
                <img style={{width:"250px"}} src={dialog?.image} alt={dialog?.text || ""}></img>
            </center>
            <div className={"text-gray-600 m-4"}>
                {dialog?.text}
            </div>
            <div>
                {(actions?.orderCreation === true) && (
                    <button 
                        onClick={(e) => {
                            e.preventDefault();
                            setOpenNewOrderModal(true);
                        }}
                        className="rounded mt-2 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                            Auftrag erstellen
                    </button>
                )}
                {(actions?.planCreation === true) && (
                    <Link 
                        to={"/plans/create"} 
                        className="rounded mt-2 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                            Plan erfassen
                    </Link>
                )}
                {(actions?.mapCreation === true) && (
                    <button 
                        onClick={(e) => {
                            e.preventDefault();
                            newItem('map');
                        }}
                        className="rounded mt-2 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                            Karte erstellen
                    </button>
                )}
            </div>
        </div>
    )
}